import jsSHA from "jssha"; // npm install jssha
import React, { Component } from "react";
import { getRequestParams } from "../../src/helpers/globalfunctions.js";
import { ButtonSkeleton } from "./skeleton/SkeletonElement.js";

export class LoginComponent extends Component {
  static displayName = LoginComponent.name;

  constructor(props) {
    super(props);
    const queryString = require("query-string");
    var parsed = queryString.parse(this.props.location.search);

    //console.log(parsed.userToken);
    const savedUserName = localStorage.getItem("remember_userName") || "";
    const savedPassword = localStorage.getItem("remember_password") || "";
    const rememberMe = !!savedUserName;

    this.state = {
      userName: savedUserName,
      password: savedPassword,
      rememberMe: rememberMe,
      isSubmitted: false,
      message: "",
      ipAddress: "127.0.0.1",
      latitude: 0,
      longitude: 0,
      errors: {
        userName: "",
        password: "",
      },
      userToken: this.props.location.search !== "" ? parsed.userguid : "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.clearControl = this.clearControl.bind(this);
    this.calcHash = this.calcHash.bind(this);
    this.uuidv4 = this.uuidv4.bind(this);
    //console.log(process.env.REACT_APP_API_BASE_URL);
  }

  clearControl() {
    this.setState({
      userName: this.state.rememberMe ? this.state.userName : "",
      password: this.state.rememberMe ? this.state.password : "",
      isSubmitted: false,
      message: "",
      errors: {
        userName: "",
        password: "",
      },
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleValidation() {
    let formIsValid = true;
    try {
      let errors = this.state.errors;
      errors.userName = "";
      errors.password = "";
      this.setState({ message: "" });

      if (this.state.userName === "") {
        formIsValid = false;
        errors.userName = "Please enter username.";
      }

      if (this.state.password === "") {
        formIsValid = false;
        errors.password = "Please enter password.";
      }
      this.setState({ errors: errors });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleValidation function",
        err,
      );
      formIsValid = false;
    }
    return formIsValid;
  }

  calcHash(value, securityKey) {
    try {
      let shaObj = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
      shaObj.update(value);
      let saltText = shaObj.getHash("HEX");

      let shaObj2 = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
      shaObj2.update(saltText + securityKey);

      return shaObj2.getHash("HEX");
    } catch (err) {
      console.log("Error in " + this.displayName + ".calcHash function", err);
    }
  }

  uuidv4() {
    return "00-0-4-1-000".replace(/[^-]/g, (s) =>
      (((Math.random() + ~~s) * 0x10000) >> s).toString(16).padStart(4, "0"),
    );
  }

  async getRedirectUser() {
    var request = {};
    request.Token = this.state.userToken;
    const requestParams = getRequestParams("POST", request);
    const response = await fetch(
      process.env.REACT_APP_API_BASE_URL + "RedirectUser",
      requestParams,
    );
    const data = await response.json();
    if (data.payload != null) {
      this.setState({ userName: data.payload });
      this.login();
    }
  }

  componentDidMount() {
    if (this.state.userToken !== "") {
      this.getRedirectUser();
    }
    navigator.geolocation.getCurrentPosition((position) => {
      console.log("Latitude is :", position.coords.latitude);
      console.log("Longitude is :", position.coords.longitude);
      this.setState({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      });
    });
    /*try {
            fetch("//api.ipify.org/?format=jsonp?callback=?",
                {
                    method: 'GET',
                    headers: {},
                })
                .then(response => { if (response.ok) { return response.text() } })
                .then(ip => {
                    console.log("ip", ip)
                    this.setState({
                        ipAddress: ip
                    });
                });
        } catch (err) {
            console.log("Error in " + this.displayName + ".componentDidMount function", err);
        }*/
  }

  async login() {
    try {
      var userName = this.state.userName;
      var password = this.state.password;
      const requestParams = getRequestParams("GET", null);
      let apiUrl = `${process.env.REACT_APP_API_BASE_URL}authentication/Validate/${userName}/${password}`;
      const response = await fetch(apiUrl, requestParams);
      const data = await response.json();
      if (data.isSuccess) {
        if (this.state.rememberMe) {
          localStorage.setItem("remember_userName", this.state.userName);
          localStorage.setItem("remember_password", this.state.password);
        } else {
          localStorage.removeItem("remember_userName");
          localStorage.removeItem("remember_password");
        }
        sessionStorage.setItem("session_userId", data.payload.id);
        sessionStorage.setItem("session_userTypeId", data.payload.userTypeId);
        sessionStorage.setItem(
          "session_userTypeName",
          data.payload.userTypeName,
        );
        sessionStorage.setItem("session_userName", data.payload.userName);
        sessionStorage.setItem("session_firstName", data.payload.firstName);
        sessionStorage.setItem("session_lastName", data.payload.lastName);
        sessionStorage.setItem(
          "session_loginUserName",
          data.payload.loginUserName,
        );
        sessionStorage.setItem("session_email", data.payload.email);
        sessionStorage.setItem("session_phoneNumber", data.payload.phoneNumber);
        sessionStorage.setItem("session_isActive", data.payload.isActive);
        sessionStorage.setItem("session_airlineCode", data.payload.airlineCode);
        sessionStorage.setItem("session_icaoCode", data.payload.icaoCode);
        sessionStorage.setItem(
          "session_socketApiUrl",
          data.payload.socketApiUrl,
        );
        //window.location.href = "/dashboard";
        window.location.replace("/dashboard");
      } else {
        this.setState({ isSubmitted: false, message: data.message });
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".componentDidMount function",
        err,
      );
      this.setState({
        isSubmitted: false,
        message: "Unable to validate login.",
      });
    }
  }

  async handleSubmit(e) {
    try {
      e.preventDefault();
      if (this.handleValidation()) {
        this.setState({ isSubmitted: true });
        this.login();
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleSubmit function",
        err,
      );
      this.setState({
        isSubmitted: false,
        message: "Oops something went worng !!!",
      });
    }
  }

  render() {
    return (
      <div className="d-flex flex-wrap min-vh-100">
        {/* Left Panel - Login Form */}
        <div
          className="col-lg-3 col-12 d-flex flex-column"
          style={{ background: "#f4f6fb" }}
        >
          <div className="flex-grow-1 d-flex align-items-center justify-content-center">
            <div className="w-100 px-4 py-4">
              {/* Logos */}
              <div className="text-center mb-3">
                <img
                  src="https://track.utwiz.com/assets/img/logo_sst_utwiz2.png"
                  alt="UTWiz logo"
                  style={{ width: 180 }}
                  className="mb-3"
                />
              </div>
              <div className="text-center mb-3">
                <p className="text-muted mb-1" style={{ fontWeight: 500 }}>
                  Welcome to
                </p>
                <img
                  src="https://akasa.utwiz.com/assets/img/logo_akasa_air.png"
                  alt="Akasa Air"
                  style={{ width: 130 }}
                />
                <p className="text-muted mt-2" style={{ fontSize: "0.85rem" }}>
                  Sign in to your account to continue
                </p>
              </div>

              {/* Form Card */}
              <div className="bg-white rounded-3 shadow p-4">
                <form
                  method="POST"
                  action="#"
                  className="needs-validation"
                  noValidate=""
                >
                  <div className="mb-3">
                    <label
                      htmlFor="userName"
                      className="form-label fw-semibold"
                      style={{ fontSize: "0.85rem" }}
                    >
                      Username
                    </label>
                    <div className="input-group input-group-lg">
                      <span
                        className="input-group-text bg-light border-end-0 text-muted"
                        style={{ borderRadius: "10px 0 0 10px" }}
                      >
                        <i className="fas fa-user"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control bg-light border-start-0"
                        id="userName"
                        name="userName"
                        placeholder="Enter your username"
                        maxLength={50}
                        tabIndex="1"
                        value={this.state.userName}
                        onChange={this.handleInputChange}
                        required
                        autoFocus
                        style={{
                          borderRadius: "0 10px 10px 0",
                          fontSize: "0.95rem",
                        }}
                      />
                    </div>
                    {this.state.errors["userName"].length > 0 && (
                      <span className="error-msg">
                        {this.state.errors["userName"]}
                      </span>
                    )}
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="password"
                      className="form-label fw-semibold"
                      style={{ fontSize: "0.85rem" }}
                    >
                      Password
                    </label>
                    <div className="input-group input-group-lg">
                      <span
                        className="input-group-text bg-light border-end-0 text-muted"
                        style={{ borderRadius: "10px 0 0 10px" }}
                      >
                        <i className="fas fa-lock"></i>
                      </span>
                      <input
                        id="password"
                        type="password"
                        className="form-control bg-light border-start-0"
                        placeholder="Enter your password"
                        maxLength={50}
                        name="password"
                        value={this.state.password}
                        onChange={this.handleInputChange}
                        tabIndex="2"
                        required
                        style={{
                          borderRadius: "0 10px 10px 0",
                          fontSize: "0.95rem",
                        }}
                      />
                    </div>
                    {this.state.errors["password"].length > 0 && (
                      <span className="error-msg">
                        {this.state.errors["password"]}
                      </span>
                    )}
                    {this.state.message.length > 0 && (
                      <span className="error-msg">{this.state.message}</span>
                    )}
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name="rememberMe"
                        className="custom-control-input"
                        tabIndex="3"
                        id="remember-me"
                        checked={this.state.rememberMe}
                        onChange={this.handleInputChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="remember-me"
                      >
                        Remember Me
                      </label>
                    </div>
                    <a
                      href="/forgot-password"
                      className="text-muted"
                      style={{ fontSize: "0.82rem" }}
                    >
                      Forgot Password?
                    </a>
                  </div>

                  {this.state.isSubmitted && (
                    <ButtonSkeleton
                      className={"btn btn-primary btn-lg btn-block"}
                      iconClassName={"fas fa-sign-in-alt me-2"}
                      iconFontSize={"20px"}
                      text={"Login"}
                      showDotedLoader={true}
                      dotedLoaderMarginTop={"10px"}
                    />
                  )}
                  {!this.state.isSubmitted && (
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg btn-block"
                      tabIndex="4"
                      onClick={this.handleSubmit}
                    >
                      <i
                        className="fas fa-sign-in-alt me-2"
                        style={{ fontSize: "20px" }}
                      />
                      &nbsp;Login
                    </button>
                  )}
                </form>

                <div className="text-center mt-3">
                  <small>
                    <a href="/forgot-password" className="text-muted">
                      Need help logging in? Click here
                    </a>
                  </small>
                </div>
              </div>
            </div>
          </div>
          {/* end flex-grow-1 */}

          {/* Footer — pinned to bottom of left panel */}
          <div
            style={{
              background: "linear-gradient(135deg, #f8f9fc 0%, #ffffff 100%)",
              borderTop: "1px solid #e4e7ed",
              boxShadow: "0 -4px 16px rgba(0,0,0,0.06)",
              padding: "0.75rem 1.5rem",
            }}
          >
            {/* Powered by row */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.45rem",
                marginBottom: "0.45rem",
              }}
            >
              <span
                style={{
                  fontSize: "0.7rem",
                  color: "#aab0bb",
                  fontWeight: 500,
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                }}
              >
                Powered by
              </span>
              <a
                href="https://www.plexitech.com/"
                style={{ textDecoration: "none", lineHeight: 1 }}
              >
                <img
                  src="../assets/img/logo-plexitech2.png"
                  alt="PlexiTech"
                  style={{ height: 22, opacity: 0.88 }}
                />
              </a>
            </div>

            {/* Divider */}
            <div
              style={{
                height: "1px",
                background:
                  "linear-gradient(90deg, transparent, #dde1ea, transparent)",
                marginBottom: "0.45rem",
              }}
            />

            {/* Copyright row */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.5rem",
                flexWrap: "wrap",
              }}
            >
              <span style={{ fontSize: "0.68rem", color: "#b0b7c3" }}>
                &copy; {new Date().getFullYear()} Akasa Air. All rights
                reserved.
              </span>
              <span style={{ color: "#d0d5df", fontSize: "0.65rem" }}>|</span>
              <a
                href="https://www.akasaair.com/privacypolicy"
                style={{
                  fontSize: "0.68rem",
                  color: "#095590",
                  textDecoration: "none",
                  fontWeight: 600,
                  letterSpacing: "0.02em",
                  transition: "color 0.2s",
                }}
                onMouseEnter={(e) => (e.target.style.color = "#0671b8")}
                onMouseLeave={(e) => (e.target.style.color = "#095590")}
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
        {/* end left panel */}

        {/* Right Panel - Background Image */}
        <div
          className="col-lg-9 col-12 d-none d-lg-flex align-items-end position-relative"
          style={{
            backgroundImage: "url('../assets/img/banner_akasa_air.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(to top, rgba(10,20,60,0.82) 0%, rgba(10,20,60,0.35) 55%, rgba(10,20,60,0.1) 100%)",
            }}
          ></div>
          <div
            className="position-relative text-white p-5 pb-4"
            style={{ zIndex: 2 }}
          >
            <h1 className="mb-4 fw-bold" style={{ fontSize: "2rem" }}>
              Complete Crew &amp; Logistics Solution
            </h1>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex align-items-start gap-3">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{
                    width: 44,
                    height: 44,
                    background: "rgba(255,255,255,0.15)",
                    borderRadius: "50%",
                  }}
                >
                  <i className="fas fa-headset"></i>
                </div>
                <div>
                  <div className="fw-semibold">Support</div>
                  <div style={{ fontSize: "0.875rem", opacity: 0.85 }}>
                    From 10:00 am to 6:00 pm &mdash; Call 022 42129000
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-start gap-3">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{
                    width: 44,
                    height: 44,
                    background: "rgba(255,255,255,0.15)",
                    borderRadius: "50%",
                  }}
                >
                  <i className="fas fa-globe"></i>
                </div>
                <div>
                  <div className="fw-semibold">Nationwide</div>
                  <div style={{ fontSize: "0.875rem", opacity: 0.85 }}>
                    Go ahead with the BEST! All India sales and service network.
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-start gap-3">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{
                    width: 44,
                    height: 44,
                    background: "rgba(255,255,255,0.15)",
                    borderRadius: "50%",
                  }}
                >
                  <i className="fas fa-tint"></i>
                </div>
                <div>
                  <div className="fw-semibold">Fuel Savings</div>
                  <div style={{ fontSize: "0.875rem", opacity: 0.85 }}>
                    Guaranteed fuel savings. Calculate how much you will save
                    with us!
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
